import script from "./PendingUsersCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PendingUsersCard.vue?vue&type=script&setup=true&lang=ts"

import "./PendingUsersCard.vue?vue&type=style&index=0&id=767adc26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-767adc26"]])

export default __exports__